import styled from "styled-components";

// TEXT

// STYLES
export const Icon = styled.svg<{ $rotation: number; $offset: number }>`
  transform: rotate(${({ $rotation }) => $rotation}deg)
    translate(0px, ${({ $offset }) => $offset}px);
  transform-origin: center;
`;

// DATA

// TYPES
export type ChevronOrientation = "down" | "up" | "left" | "right";

// CONSTANTS
const orientationMap: Record<ChevronOrientation, number> = {
  down: 0,
  up: 180,
  left: 90,
  right: 270,
};

// FUNCTIONS
// We want to shift the icon slightly to the side when it's pointing left or right
export const getOffsetAndRotation = (
  orientation: ChevronOrientation | number,
) => {
  const rotation =
    typeof orientation === "number"
      ? orientation
      : orientationMap[orientation] || 0;
  const offset =
    Math.round(Math.abs(Math.sin((rotation * Math.PI) / 180)) * 15) / 10;

  return { offset, rotation };
};

// ASSETS
